import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { getBranchList, getCatalogList } from '../setting/services/settingApi'
import api from '../../api/api'
import { REPORT_CONFIG } from './config'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { saveAs } from 'file-saver';

const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReportDialySale() {
    const [branchs, setBranchs] = useState([])
    const [Catalog, setCatalog] = useState([])
    const [CatalogNo, setCatalogNo] = useState('')
    const [BranchNo, setBranchsNo] = useState('')
    const [date, setDate] = useState(dayjs(new Date()))
    const [sumValue, setSumValue] = useState()
    const [reports, setReports] = useState([])
    const { profile } = useSelector(state => state.profile)
    const [loading, setloading] = useState(false);
    const [loadingDownload, setloadingDownload] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        getBranchList(null, setBranchs)
        getCatalogList(null, setCatalog)
        getReportDialySale('data')
    }, [])


    async function getReportDialySale(mode, format, date, branchNo, catalogNo) {
        let _params = '';
        let _date = '';
        let _format = '';
        let _branchNo = '';
        let _catalogNo = '';
        const url = `${REPORT_CONFIG.requests.getDialySaleReport.url}/${mode}`;
        if (date) {
            _date = 'date=' + date;
        }
        if (format && mode === 'file') {
            _format = '&format=' + format;
        }
        if (branchNo) {
            _branchNo = '&branchNo=' + (branchNo !== '-'  ? branchNo : '');
        }
        if (catalogNo) {
            _catalogNo = '&c=' + (catalogNo !== '-'  ? catalogNo : '');
        }
        _params = '?' + _date + _format + _branchNo + _catalogNo


        if (mode === 'file') {

            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานการจำหน่ายเมล็ดพันธุ์ (ประจำวัน) (กมข-40401)');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานการจำหน่ายเมล็ดพันธุ์ (ประจำวัน) (กมข-40401)');
            }

            setloadingDownload(false)
            // this.loading.download = false;
        } else {
            setloading(true)
            const res = await api.get(url + (_params || '?date=' + dayjs(new Date).format('YYYY-MM-DD')))
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    function calculateSum() {
        const sumValue = {
            Stock: {
                PreviousBalance: 0,
                ProductionTarget: 0,
                ReceiveToday: 0,
                Receive: 0,
                TransferInToday: 0,
                TransferIn: 0,
                TransferOutToday: 0,
                TransferOut: 0,
                Balance: 0
            },
            Sale: {
                NormalQty: 0,
                NormalAmount: 0,
                Discount5Qty: 0,
                Discount5Amount: 0,
                Discount7Qty: 0,
                Discount7Amount: 0,
                Discount8Qty: 0,
                Discount8Amount: 0,
                PromotionQty: 0,
                PromotionAmount: 0,
                TransferOutQty: 0,
                CampaignQty: 0,
                CampaignAmount: 0,
                AuctionQty: 0,
                AuctionAmount: 0,
                SpecialQty: 0,
                SpecialAmount: 0,
                ReserveQty: 0,
                TotalQty: 0,
                TotalAmount: 0
            },
            GrandTotalQty: 0,
            GrandTotalAmount: 0,
            FinalBalance: 0
        }

        for (const row of reports) {
            sumValue.Stock.PreviousBalance += row.Stock.PreviousBalance
            // this.sumValue.Stock.ProductionTarget += row.Stock.ProductionTarget
            sumValue.Stock.ReceiveToday += row.Stock.ReceiveToday
            sumValue.Stock.Receive += row.Stock.Receive
            sumValue.Stock.TransferInToday += row.Stock.TransferInToday
            sumValue.Stock.TransferIn += row.Stock.TransferIn
            sumValue.Stock.TransferOutToday += row.Stock.TransferOutToday
            sumValue.Stock.TransferOut += row.Stock.TransferOut
            sumValue.Stock.Balance += row.Stock.Balance

            sumValue.Sale.NormalQty += row.Sale.NormalQty
            sumValue.Sale.NormalAmount += row.Sale.NormalAmount
            sumValue.Sale.Discount5Qty += row.Sale.Discount5Qty
            sumValue.Sale.Discount5Amount += row.Sale.Discount5Amount
            sumValue.Sale.Discount7Qty += row.Sale.Discount7Qty
            sumValue.Sale.Discount7Amount += row.Sale.Discount7Amount
            sumValue.Sale.Discount8Qty += row.Sale.Discount8Qty
            sumValue.Sale.Discount8Amount += row.Sale.Discount8Amount
            sumValue.Sale.PromotionQty += row.Sale.PromotionQty
            sumValue.Sale.PromotionAmount += row.Sale.PromotionAmount
            // this.sumValue.Sale.TransferOutQty += row.Sale.TransferOutQty
            sumValue.Sale.AuctionQty += row.Sale.AuctionQty
            sumValue.Sale.AuctionAmount += row.Sale.AuctionAmount
            sumValue.Sale.SpecialQty += row.Sale.SpecialQty
            sumValue.Sale.SpecialAmount += row.Sale.SpecialAmount
            sumValue.Sale.CampaignQty += row.Sale.CampaignQty
            sumValue.Sale.CampaignAmount += row.Sale.CampaignAmount
            sumValue.Sale.ReserveQty += row.Sale.ReserveQty
            sumValue.Sale.TotalQty += row.Sale.TotalQty
            sumValue.Sale.TotalAmount += row.Sale.TotalAmount

            sumValue.GrandTotalQty += row.GrandTotalQty
            sumValue.GrandTotalAmount += row.GrandTotalAmount
            sumValue.FinalBalance += row.FinalBalance
        }
        setSumValue(sumValue)
    }
    useEffect(() => {
        calculateSum()
    }, [reports])
    async function LoadReport() {
        const dateFormat = date ? dayjs(date).format('YYYY-MM-DD') : ''
        getReportDialySale('data', undefined, dateFormat, BranchNo, CatalogNo)
    }



    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid" >
                    <form >
                        <div class="row  no-gutters">
                            <div class="col-12 col-lg-12">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">
                                    <div class="col-lg-3 col-md-12">

                                        <label class="labelInput">วันที่</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={date} onChange={e => setDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: date } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>

                                    </div>
                                    {profile?.BranchNo?.BranchNo === '00' &&
                                        <div class="col-lg-3 col-md-12">

                                            <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <FormControl variant="standard" fullWidth >
                                                    <Select value={BranchNo || '-'} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                        {branchs?.map((x) => (
                                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>

                                        </div>}
                                    <div class="col-lg-3 col-md-12">

                                        <label class="labelInput">พันธุ์ข้าว</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={CatalogNo || '-'} onChange={e => setCatalogNo(e.target.value)} disableUnderline >
                                                <MenuItem value='-'>-</MenuItem>
                                                    {Catalog?.map((x) => (
                                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>

                                    </div>
                                    <div class="col-3 d-flex align-items-center">

                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>


                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-lg-12">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานการจำหน่ายเมล็ดพันธุ์ (ประจำวัน) (กมข-40401)
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const dateFormat = date ? dayjs(date).format('YYYY-MM-DD') : ''
                                                getReportDialySale('file', '', dateFormat, BranchNo, CatalogNo)
                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const dateFormat = date ? dayjs(date).format('YYYY-MM-DD') : ''
                                                getReportDialySale('file', 'pdf', dateFormat, BranchNo, CatalogNo)
                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div>

                                </div>
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">

                                        <div class="table-responsive-sm" style={{ height: 'auto' }}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col " rowspan="2" class="text-center">ที่</th>
                                                        <th scope="col " rowspan="2" class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col " rowspan="2" class="text-center">ฤดู</th>
                                                        <th scope="col " rowspan="2" class="text-center">ปี</th>
                                                        <th scope="col " rowspan="2" class="text-center">พันธุ์</th>
                                                        <th scope="col " rowspan="2" class="text-center">ชั้นพันธุ์</th>
                                                        <th scope="col " rowspan="2" class="text-center">คงคลังยกมา (ณ 30 ก.ย.) (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">รับเมล็ดพันธุ์เข้าคลัง (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">รับเมล็ดพันธุ์เข้าคลังสะสม (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">รับโอน (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">รับโอนสะสม (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">โอนให้ (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">โอนให้สะสม (กก.)</th>
                                                        <th scope="col " rowspan="2" class="text-center">เมล็ดพันธุ์ทั้งหมด (กก.)</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายราคาปกติ</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายแบบมีส่วนลด 5%</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายแบบมีส่วนลด 7%</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายแบบมีส่วนลด 8%</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายลดราคาเฉพาะกิจ</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายราคาขายทอดตลาด</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายราคาโครงการพิเศษ</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายโครงการ/ส่วนราชการ</th>
                                                        <th scope="col " rowspan="2" class="text-center">สำรอง (กก.)</th>
                                                        <th scope="col " colspan="2" class="text-center">รวมจำหน่าย</th>
                                                        <th scope="col " colspan="2" class="text-center">จำหน่ายสะสม</th>
                                                        <th scope="col " rowspan="2" class="text-center">เมล็ดพันธุ์เหลือคงคลัง (กก.)</th>
                                                    </tr>
                                                    <tr>

                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                        <th scope="col " class="text-center">ปริมาณ (กก.)</th>
                                                        <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                                    </tr>

                                                </thead>
                                                <tbody class="">
                                                    {reports?.map((d, i) => (
                                                        <tr >
                                                            <td class="text-center">{i + 1}</td>
                                                            <td class="text-center">{d?.BranchName}</td>
                                                            <td class="text-center">
                                                                <span style={{ fontWeight: 'bold' }}>{d?.Season}
                                                                </span>
                                                            </td>
                                                            <td class="text-center">{d?.Year}</td>
                                                            <td class="text-center">{d?.CatalogName}</td>
                                                            <td class="text-center">{d?.ClassName}</td>
                                                            <td class="text-center">{d?.Stock?.PreviousBalance.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.ReceiveToday.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.Receive.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.TransferInToday.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.TransferIn.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.TransferOutToday.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.TransferOut.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Stock?.Balance.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Sale?.NormalQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.NormalAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.Discount5Qty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.Discount5Amount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.Discount7Qty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.Discount7Amount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.Discount8Qty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.Discount8Amount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.PromotionQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.PromotionAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.AuctionQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.AuctionAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.SpecialQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.SpecialAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.CampaignQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.CampaignAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Sale?.ReserveQty.toLocaleString()}</td>
                                                            <td class="text-center">{d?.Sale?.TotalQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.Sale?.TotalAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.GrandTotalQty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.GrandTotalAmount).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.FinalBalance.toLocaleString()}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                                <thead class="sticky-tfooter">
                                                    <tr>
                                                        <th scope="col " colspan="6" class="text-center">รวม</th>
                                                        <th class="text-center">{sumValue?.Stock?.PreviousBalance.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.ReceiveToday.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.Receive.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.TransferInToday.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.TransferIn.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.TransferOutToday.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.TransferOut.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Stock?.Balance.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Sale?.NormalQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.NormalAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.Discount5Qty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.Discount5Amount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.Discount7Qty?.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.Discount7Amount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.Discount8Qty?.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.Discount8Amount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.PromotionQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.PromotionAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.AuctionQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.AuctionAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.SpecialQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.SpecialAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.CampaignQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.CampaignAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.Sale?.ReserveQty.toLocaleString()}</th>
                                                        <th class="text-center">{sumValue?.Sale?.TotalQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.Sale?.TotalAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.GrandTotalQty.toLocaleString()}</th>
                                                        <th class="text-center">{parseFloat(sumValue?.GrandTotalAmount).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th class="text-center">{sumValue?.FinalBalance.toLocaleString()}</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {reports.length === 0 &&
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>}
                            </div>

                        </div>

                    </form>
                </div>
            </Page>
        </div>
    )
}
